Ember.Handlebars.registerBoundHelper('linkify', function(value) {
    value = window.linkifyStr(value, {
        nl2br: true
    })
    value = value.htmlSafe()
    return value
})
